import * as React from "react";
import {useState} from "react";
import {
    ToolbarType,
    UitkCalloutCard,
    UitkCalloutCardTheme,
    UitkPageLoader,
    UitkSpacing,
    UitkToolbar,
    UitkToolbarSecondaryAction
} from "@egencia/uitk-react";
import {logClickEvent} from "../common/omnitureLog.js";
import {FaqSearch} from "./faq-search.jsx";
import {ArticleError} from "./article-error";

export const PanelHeader = props => {

    const {
        panelViewName = "DefaultPage",
        onFaqSearch,
        hasBackBtn,
        hasSearch
    } = props;

    const headerTitleTextSearch = uitk.i18n.msg('panel_header_section_title_search_result');
    const headerTitleTextDefault = uitk.i18n.msg('panel_header_section_title_egencia_help');
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(false);

    function handlePanelBack(e) {
        e.preventDefault();
        e.stopPropagation();
        logClickEvent(searchValue ? "Search" : "DefaultPage", '.BackButton.Clicked');

        if (searchValue) {
            setSearchValue("");
        } else {
            if (EG.bootstrapped.overrideBack) {
                // return to panel index (use anonymous if anonymous in url)
                window.location = window.location.pathname.includes('anonymous')
                    ? "/help-center/panel/anonymous"
                    : "/help-center/panel";
            } else {
                window.history.back();
            }
            setLoading(true);
        }
    }

    function handlePanelClose(e) {
        e.preventDefault();
        e.stopPropagation();
        logClickEvent(searchValue ? "Search" : panelViewName, '.CloseButton.Clicked');
        // Delete panel cookie when user closes the panel
        uitk.deleteCookie('search_content');
        window.parent.postMessage({'message': 'close-modal'}, '*');
    }

    function onSearch(value) {
        setSearchValue(value);
        onFaqSearch(value);
    }

    function outageBannerEnabled() {
        if (EG.bootstrapped && EG.bootstrapped.alertMessaging) {
            return EG.bootstrapped.alertMessaging.beforeOutage || EG.bootstrapped.alertMessaging.duringOutage;
        }
    }

    let alertMessagingBanner;
    if (outageBannerEnabled()) {
        let bannerText = (EG.bootstrapped.alertMessaging.beforeOutage) ? uitk.i18n.msg('banner.message.before_maintenance') : uitk.i18n.msg('banner.message.in_maintenance');
        alertMessagingBanner =
            <UitkSpacing margin={"three"}>
                <div>
                    <UitkCalloutCard
                        theme={UitkCalloutCardTheme.warning}
                        headingText={bannerText}
                    />
                </div>
            </UitkSpacing>
    }

    return (
        <div className="panel-header">
            <UitkToolbar
                actionInlineStart={hasBackBtn ? handlePanelBack : handlePanelClose}
                typeInlineStart={hasBackBtn ? ToolbarType.BACK : ToolbarType.CLOSE}
                header={searchValue ? headerTitleTextSearch : props.title ? props.title : headerTitleTextDefault}
                actionContent={hasBackBtn && (
                    <UitkToolbarSecondaryAction
                        action={handlePanelClose}
                        icon={{iconName: 'close'}}
                    />
                )}
            />
            {alertMessagingBanner}
            {EG.bootstrapped.articleError &&
                <UitkSpacing margin={{inline: "two", blockstart: "two"}}>
                    <div>
                        <ArticleError/>
                    </div>
                </UitkSpacing>
            }
            {(hasSearch && EG.bootstrapped.llmFeatureToggle !== true) &&
                <UitkSpacing padding={"two"}>
                    <div>
                        <FaqSearch onSearch={onSearch} value={searchValue}/>
                    </div>
                </UitkSpacing>
            }
            <UitkPageLoader visible={loading}/>
        </div>
    )
};